import SimpleLightbox from 'simple-lightbox';

window.addEventListener("load", function(event) {
    let lightbox = new SimpleLightbox({elements: '.p-portfolio-detail__gallery-inner a'});
    let clothesLightBox = new SimpleLightbox({elements: '.card-clothes a'});
    let promoLightBox = new SimpleLightbox({elements: '.p-promo__gallery-item a'});
});
